import { render, staticRenderFns } from "./Automatic.vue?vue&type=template&id=108f0e3e&scoped=true&"
import script from "./Automatic.vue?vue&type=script&lang=js&"
export * from "./Automatic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108f0e3e",
  null
  
)

export default component.exports